import { render } from "./LevelDetail.vue?vue&type=template&id=66ddfde8&scoped=true"
import script from "./LevelDetail.vue?vue&type=script&lang=js"
export * from "./LevelDetail.vue?vue&type=script&lang=js"

import "./LevelDetail.vue?vue&type=style&index=0&id=66ddfde8&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ddfde8"]])

export default __exports__